module.exports = __webpack_public_path__ + "img/michael-gawanda.fda89451.jpg";